const topicItems = [
  { id: 1, label: '#暑期档', hot: '98万讨论' },
  { id: 2, label: '#国产剧崛起', hot: '86万讨论' },
  { id: 3, label: '#科幻大片', hot: '72万讨论' },
  { id: 4, label: '#悬疑烧脑', hot: '65万讨论' },
  { id: 5, label: '#韩剧推荐', hot: '59万讨论' },
  { id: 6, label: '#动漫新番', hot: '54万讨论' },
  { id: 7, label: '#纪录片', hot: '48万讨论' },
  { id: 8, label: '#经典重温', hot: '43万讨论' },
  { id: 9, label: '#综艺热播', hot: '37万讨论' },
  { id: 10, label: '#冷门佳作', hot: '31万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            影视圈最热讨论话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[800px] mx-auto">
          {topicItems.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.hot}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}